import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import Style from './SocialIcons.module.scss';
import Icon from '../../../../../components/Icon';
import { makeSelectSeriesDetailSeriesData } from '../../../selectors';

const SocialIcons = () => {
  const data = useSelector(makeSelectSeriesDetailSeriesData);
  const { facebookId, instagramId, twitterId, youtubeId } = data;

  const buildSocials = content => {
    const socials = [
      {
        name: 'Facebook',
        key: 'facebookId',
        icon: 'fb-logo',
        format: id => `https://www.facebook.com/${id}/`,
      },
      {
        name: 'Twitter',
        key: 'twitterId',
        icon: 'twitter-logo',
        format: id => `https://twitter.com/${id}`,
      },
      {
        name: 'Instagram',
        key: 'instagramId',
        icon: 'instagram',
        format: id => `https://www.instagram.com/${id}/`,
      },
      {
        name: 'Youtube',
        key: 'youtubeId',
        icon: 'youtube',
        format: id => `https://www.youtube.com/c/${id}/`,
      },
    ];
    return socials.map(item => {
      const id = _.get(content, item.key);
      if (!id) return null;
      const { key, name } = item;
      const url = item.format(id);
      const { icon } = item;
      return { key, name, url, icon };
    });
  };

  const socials = buildSocials({
    facebookId,
    instagramId,
    twitterId,
    youtubeId,
  });
  return (
    <div className={Style.social}>
      {socials.map(item => {
        if (!item) return null;
        return (
          <div key={item.key} className={Style.icon}>
            <a href={item.url} target="_blank" rel="noopener noreferrer" title={item.name}>
              <Icon size="medium-large" viewBox="0 0 1024 1024" color="white" icon={item.icon} />
            </a>
          </div>
        );
      })}
    </div>
  );
};

export default SocialIcons;
